module.exports = __webpack_public_path__ + "img/base_divers_tabac_presse.188ca537.svg";